import LuxonUtils from '@date-io/luxon';
import MuiPickersUtilsProvider from "@material-ui/pickers/MuiPickersUtilsProvider";
import {
  KeyboardDatePicker, KeyboardTimePicker,
} from '@material-ui/pickers';
import {
  getIn, useFormikContext,
} from 'formik';
import React, {
  useEffect,
} from 'react';
import {
  isDateOnlyPicker, isTimeOnlyPicker,
} from '../../types';
import FieldError from '../../Utils/FieldError';
import {
  DateTimeFieldValue, FieldPropsCommon,
} from '../types';
import {
  onChange,
} from '../utils';


type Props<T, K extends keyof T> = FieldPropsCommon<T, K> & DateTimeFieldValue<T, K>;

const DateTimeField = <FormModel, FormModelKey extends keyof FormModel>(props: Props<FormModel, FormModelKey>) => {
  const {
    fieldOptions,
    location,
    title,
    disabled,
  } = props;

  const {
    values,
    handleChange,
    isSubmitting,
    setFieldTouched,
    errors,
    touched,
  } = useFormikContext<FormModel>();

  const value: Date = getIn(values, location);
  const onValueChange = onChange(handleChange, location);
  const error = getIn(errors, location);
  const isTouched = getIn(touched, location);

  useEffect(() => {
    if (isSubmitting) {
      setFieldTouched(location);
    }
  }, [isSubmitting, location, setFieldTouched]);

  return (
    <div
      style={{
        margin: 8,
      }}
    >
      <MuiPickersUtilsProvider utils={LuxonUtils}>
        <>
          {
            !isTimeOnlyPicker(fieldOptions) && (
              <KeyboardDatePicker
                {...(fieldOptions.datePickerProps ? fieldOptions.datePickerProps : {
                })}
                label={`${title} Date Picker`}
                value={value}
                disabled={disabled}
                onBlur={() => setFieldTouched(location)}
                onChange={(date) => {
                  if (date) {
                    onValueChange(date.toJSDate());
                  }
                }}
              />
            )
          }
          {
            !isDateOnlyPicker(fieldOptions) && (
              <KeyboardTimePicker
                {...(fieldOptions.timePickerProps ? fieldOptions.timePickerProps : {
                })}
                label={`${title} Time Picker`}
                value={value}
                disabled={disabled}
                onBlur={() => setFieldTouched(location)}
                onChange={(date) => {
                  if (date) {
                    onValueChange(date.toJSDate());
                  }
                }}
              />
            )
          }
          <FieldError
            errors={error}
            touched={isTouched}
          />
        </>
      </MuiPickersUtilsProvider>
    </div>
  );
};

export default DateTimeField;
